import { SimpleDialog } from '@ysura/common';
import { useTranslation } from 'react-i18next';

type RevokeConsentComponentProps = {
  consentName: string;
  onCancelDialog: VoidFunction;
  onConfirmDialog: VoidFunction;
};

export const RevokeConsentDialog = ({
  consentName,
  onCancelDialog,
  onConfirmDialog,
}: RevokeConsentComponentProps) => {
  const { t } = useTranslation();

  return (
    <SimpleDialog
      isOpen={true}
      testId={'reject-consent-dialog'}
      title={t('components.consentCollection.revokeConsent.title')}
      description={t('components.consentCollection.revokeConsent.description', {
        consentName,
      })}
      closeDialogText={t('components.common.confirm')}
      closeDialog={onConfirmDialog}
      cancelDialogText={t('components.common.cancel')}
      cancelDialog={onCancelDialog}
    />
  );
};
